import React from 'react';
import { Button } from 'src/components/ui/button';
import { useAppSelector } from 'src/store';
import { useConfigurationContext } from 'src/provider/ConfigurationProvider';

export const ConfigurationControls = ({
  activeSettings,
  readonly,
  onEditClick,
  onCancelClick,
  onDeployClick,
}) => {
  const { isInactivePlan } = useAppSelector((s) => s.planSlice);
  const { isEditWorkflowMode } = useConfigurationContext();

  return (
    <div className="relative flex md:gap-2.5 gap-2 items-center">
      {readonly ? (
        <>
          <div className="relative flex md:gap-2.5 gap-2">
            <Button
              variant="outline"
              className={'flex gap-2 min-w-24'}
              onClick={onEditClick}
              disabled={isInactivePlan}
            >
              <p className="font-medium text-base-xs">Edit</p>
              <svg
                width="13"
                height="14"
                viewBox="0 0 13 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.44444 12.0532H2.46567L9.19244 5.3155L8.17122 4.29261L1.44444 11.0303V12.0532ZM13 13.5H0V10.4306L9.70306 0.711801C9.83849 0.576185 10.0222 0.5 10.2137 0.5C10.4052 0.5 10.5888 0.576185 10.7243 0.711801L12.7674 2.75829C12.9028 2.89395 12.9789 3.07791 12.9789 3.26973C12.9789 3.46155 12.9028 3.64551 12.7674 3.78117L4.50883 12.0532H13V13.5ZM9.19244 3.26973L10.2137 4.29261L11.2349 3.26973L10.2137 2.24685L9.19244 3.26973Z"
                  fill="#05050D"
                  fillOpacity="0.8"
                />
              </svg>
            </Button>
          </div>
          {Boolean(activeSettings && !activeSettings.is_deployed) && (
            <div className="relative flex md:gap-2.5 gap-2">
              <Button
                disabled={isInactivePlan || isEditWorkflowMode}
                variant={'green'}
                className="min-w-24"
                onClick={onDeployClick}
              >
                <span>Deploy</span>
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M14.6663 6H1.33301M9.33301 11.6667L10.9997 10L9.33301 8.33333M6.66634 8.33333L4.99967 10L6.66634 11.6667M1.33301 5.2V10.8C1.33301 11.9201 1.33301 12.4801 1.55099 12.908C1.74274 13.2843 2.0487 13.5903 2.42503 13.782C2.85285 14 3.4129 14 4.53301 14H11.4663C12.5865 14 13.1465 14 13.5743 13.782C13.9507 13.5903 14.2566 13.2843 14.4483 12.908C14.6663 12.4801 14.6663 11.9201 14.6663 10.8V5.2C14.6663 4.07989 14.6663 3.51985 14.4483 3.09202C14.2566 2.71569 13.9507 2.40973 13.5743 2.21799C13.1465 2 12.5865 2 11.4663 2H4.53301C3.4129 2 2.85285 2 2.42503 2.21799C2.0487 2.40973 1.74274 2.71569 1.55099 3.09202C1.33301 3.51984 1.33301 4.07989 1.33301 5.2Z"
                      stroke="#05050D"
                      strokeWidth="1.33333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </Button>
            </div>
          )}
        </>
      ) : (
        <>
          <div className="relative flex md:gap-2.5 gap-2">
            <Button
              disabled={isEditWorkflowMode}
              variant="outline"
              type="button"
              className="min-w-24"
              onClick={onCancelClick}
            >
              Cancel
            </Button>
          </div>
          <div className="relative flex md:gap-2.5 gap-2">
            <Button
              disabled={isEditWorkflowMode}
              form={'configuration-page-form'}
              type="submit"
              className="min-w-24"
            >
              Save
            </Button>
          </div>
        </>
      )}
    </div>
  );
};
